import useStyles from 'isomorphic-style-loader/useStyles';
import { useRef } from 'react';

import ContextPanel, { useContextPanel } from '@components/context-panel';

import s from './layout.scss';

/**
 * Internal component that bridges the global-scope context panel state to a
 * fixed-position `ContextPanel` in the app layout. Positioned from the topbar
 * to the viewport bottom, mirroring the sidenav pattern.
 */
export const GlobalContextPanel = () => {
  useStyles(s);
  const { isOpen, options } = useContextPanel('global');

  // `close()` nulls `options` synchronously; cache `exitImmediate` so
  // it survives into the close render.
  const lastExitImmediateRef = useRef(false);
  if (isOpen) {
    lastExitImmediateRef.current = !!options?.exitImmediate;
  }

  return (
    <ContextPanel.Outlet
      className={s.globalContextPanel}
      content={options?.content}
      exitImmediate={options?.exitImmediate ?? lastExitImmediateRef.current}
      header={options?.header}
      open={isOpen}
      width={options?.width}
    />
  );
};
